// src/components/workshop/BarcodeScanner.jsx
import React, { useEffect, useRef, useState } from "react";
import { BrowserMultiFormatReader, NotFoundException } from "@zxing/library";

export default function BarcodeScanner({ onDetected, onClose }) {
  const videoRef = useRef(null);
  const readerRef = useRef(null);
  const detectedRef = useRef(false);
  const [error, setError] = useState("");
  const [scanning, setScanning] = useState(true);

  useEffect(() => {
    const reader = new BrowserMultiFormatReader();
    readerRef.current = reader;

    reader
      .decodeFromVideoDevice(null, videoRef.current, (result, err) => {
        if (result && !detectedRef.current) {
          detectedRef.current = true;
          setScanning(false);
          reader.reset();
          onDetected(result.getText());
        }
        if (err && !(err instanceof NotFoundException)) {
          console.warn("[BarcodeScanner]", err?.message || err);
        }
      })
      .catch((e) => {
        setError(
          e?.name === "NotAllowedError"
            ? "Kameratilgang ble avslått. Sjekk nettleserens tillatelser."
            : `Kamera ikke tilgjengelig: ${e?.message || e}`
        );
        setScanning(false);
      });

    return () => {
      reader.reset();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        background: "rgba(0,0,0,0.85)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 400,
          background: "#111",
          borderRadius: 12,
          overflow: "hidden",
          position: "relative",
        }}
      >
        {/* Header */}
        <div
          style={{
            background: "#1f2937",
            padding: "12px 16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <span style={{ color: "#fff", fontWeight: 600, fontSize: 14 }}>
            Skann strekkode / QR-kode
          </span>
          <button
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              color: "#9ca3af",
              fontSize: 20,
              cursor: "pointer",
              lineHeight: 1,
              padding: "0 4px",
            }}
          >
            ✕
          </button>
        </div>

        {/* Video */}
        <div style={{ position: "relative", background: "#000" }}>
          <video
            ref={videoRef}
            autoPlay
            playsInline
            muted
            style={{ width: "100%", display: "block", maxHeight: 320, objectFit: "cover" }}
          />

          {/* Sikte-overlay */}
          {scanning && !error && (
            <div
              style={{
                position: "absolute",
                inset: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                pointerEvents: "none",
              }}
            >
              <div
                style={{
                  width: 220,
                  height: 100,
                  border: "2px solid rgba(255,255,255,0.8)",
                  borderRadius: 8,
                  boxShadow: "0 0 0 9999px rgba(0,0,0,0.35)",
                }}
              />
            </div>
          )}
        </div>

        {/* Status */}
        <div style={{ padding: "12px 16px", background: "#1f2937" }}>
          {error ? (
            <p style={{ color: "#f87171", fontSize: 13, margin: 0 }}>{error}</p>
          ) : scanning ? (
            <p style={{ color: "#9ca3af", fontSize: 13, margin: 0, textAlign: "center" }}>
              Hold strekkoden/QR-koden innenfor rammen…
            </p>
          ) : (
            <p style={{ color: "#4ade80", fontSize: 13, margin: 0, textAlign: "center" }}>
              Kode registrert ✓
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
